import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { RouteStore } from 'bernie-core';

import { WalkScoreViewModel } from 'src/common/models';

import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkMoreInfoTrigger } from 'uitk-react-more-info-trigger';

import { DisclaimerDialog } from 'src/common/components/common/disclaimer-dialog';

export interface WalkScoreProps {
  model: WalkScoreViewModel;
  routeStore?: RouteStore;
}

export const WalkScore: React.FunctionComponent<WalkScoreProps> = inject('routeStore')(
  observer(({ model, routeStore }) => {
    if (!model.score) {
      return null;
    }

    const routeStoreGoBack = () => routeStore.goBack();
    const LinkTracked = ClickTracker(Link);
    const dialogId = 'reviewWalkScoreDialog';
    const dialogQuery = routeStore.mergeQueryString(routeStore.search, { pwaDialogNested: dialogId });

    return (
      <div className="uitk-flex uitk-flex-gap-one">
        <>
          <span> {model.text} </span>
          <UitkMoreInfoTrigger>
            <LinkTracked
              linkName="Review Walk score Dialog"
              rfrr=".Reviews.WalkScoreDialog"
              to={{ pathname: routeStore.pathname, search: dialogQuery }}
            >
              <span className="uitk-type-bold"> {model.score} </span>
              <UitkIcon name="info_outline" size={UitkIconSize.SMALL} className="pwa-theme--grey-700" />
            </LinkTracked>
          </UitkMoreInfoTrigger>
        </>
        {model.description && (
          <DisclaimerDialog
            dialogId={dialogId}
            dialogType="pwaDialogNested"
            disclaimerText={model.description}
            handleClose={routeStoreGoBack}
            innerHTML={true}
            layerId="review-walk-score-dialog"
            disclaimerTextId="review-walk-score-text"
          />
        )}
      </div>
    );
  })
);
WalkScore.displayName = 'WalkScore';
